import React from "react";

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="w-full py-2 ">
      <nav className="bg-white-A700 shadow-md rounded-xl border border-gray-300  ">
        <ul className="flex flex-wrap justify-start space-x-2 sm:space-x-4 px-2 sm:px-4 py-1.5  relative">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.value;
            return (
              <li key={tab.value} className="relative border rounded-xl ">
                <button
                  onClick={() => onTabChange(tab.value)}
                  className={`whitespace-nowrap flex gap-1 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200
                    ${
                      isActive
                        ? "bg-gradient-to-tr  from-blue-400 to-blue-700 text-white-A700  shadow-md border-b-2  border-b-purple-400 border-r-2  border-r-purple-400 "
                        : // ? "bg-gradient-to-r text-blue-500 shadow-md border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 " :
                          "text-gray-800 hover:text-blue-600 hover:bg-blue-100 border border-blue-500"
                    }
                  `}
                >
                  {tab.icon && (
                    <span className="text-xs flex items-center ">
                      {tab.icon}
                    </span>
                  )}
                  {tab.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Tabs;
